const state = {};

const mutations = {};

const actions = {
  success({commit, dispatch}, message) {
    this.$app.$notify({
      timeout: 4000,
      message: message,
      horizontalAlign: "center",
      verticalAlign: "bottom",
      icon: "add_alert",
      type: "success"
    });
  },

  info({commit, dispatch}, message) {
    this.$app.$notify({
      timeout: 4000,
      message: message,
      horizontalAlign: "center",
      verticalAlign: "bottom",
      icon: "add_alert",
      type: "warning"
    });
  },
  error({commit, dispatch}, message) {
    this.$app.$notify({
      timeout: 4000,
      message: message,
      horizontalAlign: "center",
      verticalAlign: "bottom",
      icon: "add_alert",
      type: "danger"
    });
  }
};

const getters = {};

const alerts = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default alerts;